

import React, { useState } from "react";
import {
  Flex,
  Stack,
  Heading,
  Box,
  Input,
  Button,
  FormControl,
  FormLabel,
  Text,
  Link,
  useToast,
} from "@chakra-ui/react";
import { forgotPassword } from "../../utils/api";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const data = await forgotPassword(email);

      setMessage(data.message);

      // ✅ Show success toast if OTP sent
      if (data.message.includes("OTP")) {
        toast({
          title: "OTP Sent!",
          description: "Please check your email for the OTP.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // ✅ Navigate to verify-otp screen after 2 seconds
        setTimeout(() => {
          navigate("/verify-otp", { state: { email } });
        }, 2000);
      } else {
        // Handle if email not found
        toast({
          title: "Error",
          description: data.message || "Email not found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Forgot password error:", error);

      toast({
        title: "Server Error",
        description: "Something went wrong. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      justifyContent="center"
      alignItems="center"
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Heading color="primary">Forgot Password</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>
          <form onSubmit={handleSubmit}>
            <Stack rounded="lg" bg="#ffffff" boxShadow="lg" p={8}>
              <FormControl>
                <FormLabel>Email Address</FormLabel>
                <Input
                  type="email"
                  placeholder="Enter your registered email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </FormControl>

              {message && (
                <Text
                  fontSize="sm"
                  color={message.includes("OTP") ? "green.500" : "red.500"}
                >
                  {message}
                </Text>
              )}

              <Button
                type="submit"
                bg="primary"
                color="white"
                isLoading={loading}
                _hover={{
                  bg: "white",
                  borderColor: "primary",
                  color: "primary",
                  borderWidth: "1px",
                }}
              >
                Send OTP
              </Button>

              <Link href="/login" color="primary" textAlign="center">
                Back to Login
              </Link>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};

export default ForgotPassword;
